define(["exports", "@babel/runtime/helpers/esm/assertThisInitialized", "@babel/runtime/helpers/esm/inheritsLoose", "@babel/runtime/helpers/esm/defineProperty", "react"], function (_exports, _assertThisInitialized2, _inheritsLoose2, _defineProperty2, _react) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ErrorBoundary = void 0;
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inheritsLoose2 = _interopRequireDefault(_inheritsLoose2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _react = _interopRequireWildcard(_react);

  var ErrorBoundary = /*#__PURE__*/function (_Component) {
    (0, _inheritsLoose2.default)(ErrorBoundary, _Component);

    function ErrorBoundary() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _Component.call.apply(_Component, [this].concat(args)) || this;
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
        error: null,
        errorInfo: null
      });
      return _this;
    }

    var _proto = ErrorBoundary.prototype;

    _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
      this.setState({
        error: error,
        errorInfo: errorInfo
      });
    };

    _proto.render = function render() {
      var children = this.props.children;

      if (this.state.errorInfo) {
        return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", null, "Something went wrong."), /*#__PURE__*/_react.default.createElement("details", {
          style: {
            whiteSpace: 'pre-wrap'
          }
        }, this.state.error && this.state.error.toString(), /*#__PURE__*/_react.default.createElement("br", null), this.state.errorInfo.componentStack));
      }

      return children;
    };

    return ErrorBoundary;
  }(_react.Component);

  _exports.ErrorBoundary = ErrorBoundary;
});